import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../lib/api";
const POLL_MS = 30000;  // increased from 20s → 30s

/**
 * Polls GET /chats/consumer every 30s and returns unread message counts.
 * Only active when `enabled` is true (consumer role, logged in).
 *
 * @param {boolean} enabled
 * @returns {{ total: number, unreadMap: Object<string, number> }}
 */
export function useConsumerUnread(enabled = true) {
  const [unreadMap, setUnreadMap] = useState({});

  const fetchUnread = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/chats/consumer`, { withCredentials: true });
      const map = {};
      res.data.forEach(c => { map[c.id] = c.unread_count || 0; });
      setUnreadMap(map);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    fetchUnread();
    const id = setInterval(fetchUnread, POLL_MS);
    return () => clearInterval(id);
  }, [enabled, fetchUnread]);

  const total = Object.values(unreadMap).reduce((s, n) => s + n, 0);
  return { total, unreadMap };
}
